var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grided-template"},[_c('MenuComponent'),_c('div',[_c('default-header',{attrs:{"visible":_vm.headerVisibility}}),_c('DashboardGestao')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }